import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { userApi } from "../../api/masters/userApi";
import { generatePassword } from "../../utils/pass";

export const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showPass, setShowPass] = useState(false);

  const [form, setForm] = useState({
    id: "",
    cedula: "",
    nombre: "",
    usuario: "",
    correo: "",
    password: "",
    rol_id: "",
    estado: "1",
    es_vacunador: 0,
    realiza_citologia: 0,
  });

  // ---- Load Roles ----
  const loadRoles = async () => {
    try {
      const res = await userApi.getRoles();
      const active = res.data.filter((r) => r.estado === "1");
      setRoles(active);
    } catch {
      toast.error("Error cargando roles");
    }
  };

  // ---- Load Users ----
  const loadUsers = async () => {
    try {
      const res = await userApi.getUsers();
      setUsers(res.data || []);
    } catch {
      toast.error("Error cargando usuarios");
    }
  };

  // ---- Select User ----
  const emptyForm = {
    id: "", cedula: "", nombre: "", usuario: "",
    correo: "", password: "", rol_id: "", estado: "1", es_vacunador: 0, realiza_citologia: 0,
  };

  const loadUserById = async (id) => {
    try {
      const res = await userApi.getUserById(id);

      if (!res.success) {
        toast.error("Usuario no encontrado");
        setForm(emptyForm);   // ← resetear form si la API falla
        return;
      }

      const u = res.data;

      setForm({
        id: u.Id_usuario,
        cedula: u.identificacion || "",
        nombre: u.nombre || "",
        usuario: u.username || "",
        correo: u.email || "",
        password: "********",
        rol_id: u.rol_id,
        estado: u.estado,
        es_vacunador: Number(u.es_vacunador ?? 0),
        realiza_citologia: Number(u.RealizaCitologia ?? 0),
      });
    } catch {
      toast.error("Error consultando usuario");
      setForm(emptyForm);   // ← resetear form si el SELECT de BD falla
    }
  };

  const handleSelectUser = (id) => {
    setSelectedUser(id);
    loadUserById(id);
  };

  // ---- New User ----
  const handleNew = () => {
    setSelectedUser(null);
    setForm({
      id: "",
      cedula: "",
      nombre: "",
      usuario: "",
      correo: "",
      password: generatePassword(),
      rol_id: "",
      estado: "1",
      es_vacunador: 0,
      realiza_citologia: 0,
    });
  };

  // ---- Save User ----
  const saveUser = async () => {
    if (!form.cedula || !form.nombre || !form.usuario) {
      toast.error("Complete los campos obligatorios");
      return;
    }

    if (!form.correo) {
      toast.error("El correo es obligatorio");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.correo)) {
      toast.error("El correo no es válido");
      return;
    }

    try {
      const res = await userApi.saveUser(form);

      if (!res.success) {
        toast.error(res.message || "Error guardando usuario");
        return;
      }

      toast.success(res.message);
      loadUsers();
      handleNew();
    } catch {
      toast.error("Error guardando usuario");
    }
  };

  // Initial Load
  useEffect(() => {
    loadRoles();
    loadUsers();
  }, []);

  return {
    users,
    roles,
    search,
    setSearch,
    selectedUser,
    showPass,
    setShowPass,
    form,
    setForm,
    handleNew,
    handleSelectUser,
    saveUser,
    loadUsers,
  };
};

